import { DatabaseClient, getDatabaseClient } from '~/data/db/DatabaseClient';

export function resolveDatabaseClient(
  injected?: DatabaseClient | null
): DatabaseClient | null {
  return injected ?? getDatabaseClient();
}

export function resolveOfflineDb(
  injected?: DatabaseClient | null
): SQLitePlugin.Database | undefined {
  return resolveDatabaseClient(injected)?.raw;
}
